export default "<div class=\"tc-panel-item\">\r\n  <ng-template #tcPanelItemHost></ng-template>\r\n</div>\r\n";